import { format } from "date-fns";

export const formatAlertDate = (date: Date): string =>
	format(date, "dd.MM.yyyy");
